import loyalty from './loyalty'
import promotion from './promotion'
import profile from './profile'
import shop from './shop'
import fields from './fields'

export default (Bus) => {
  loyalty(Bus)
  promotion(Bus)
  profile(Bus)
  shop(Bus)
  fields(Bus)
}
